import { useMemoizedFn } from 'ahooks';
import { useEffect, useRef } from 'react';
export var useBroadcastChannel = function useBroadcastChannel(name, onMessage) {
  var bcRef = useRef();
  var postMessage = useMemoizedFn(function (data) {
    var _bcRef$current;
    (_bcRef$current = bcRef.current) === null || _bcRef$current === void 0 || _bcRef$current.postMessage(data);
  });
  var close = useMemoizedFn(function () {
    var _bcRef$current2;
    (_bcRef$current2 = bcRef.current) === null || _bcRef$current2 === void 0 || _bcRef$current2.close();
  });
  useEffect(function () {
    try {
      bcRef.current = new BroadcastChannel(name);
      if (onMessage) {
        bcRef.current.onmessage = function (event) {
          onMessage(event.data);
        };
      }
    } catch (error) {}
    return function () {
      close();
    };
  }, [onMessage]);
  return {
    postMessage: postMessage,
    close: close
  };
};